import { generatePath, useLocation, useParams } from 'react-router';

import { ChevronLeftIcon, EditIcon } from '@/assets/icons';
import { Button, Loading } from '@/components/common';
import FaceIdProfileDetailsCard from './FaceIdProfileDetailsCard';
import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';
import { useFaceIdProfileQuery } from '@/features/face-id-profiles/hooks';
import { useEffect } from 'react';

const FaceIdProfileDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const { data, isFetching, error } = useFaceIdProfileQuery(id || '');

  useEffect(() => {
    if (error || (!isFetching && !data)) {
      navigate(AppRoutes.NOT_FOUND, { replace: true });
    }
  }, [error, isFetching, data]);

  return (
    <div className="flex flex-col gap-base mt-xl mb-24 text-brand-primary-darkest">
      {/* Back Button */}
      <Button
        variant="link"
        className="text-neutral-n7 self-start"
        prefixIcon={<ChevronLeftIcon />}
        onClick={() => {
          // Check if we navigated here from another page (not direct access)
          const hasHistory = location.key !== 'default';

          if (hasHistory) {
            window.history.back();
          } else {
            navigate(AppRoutes.FACE_ID_PROFILES);
          }
        }}
      >
        Back to Face Profile ID
      </Button>

      {/* Header with Title and Edit Button */}
      <div className="flex items-center justify-between gap-4 pb-base-plus">
        <h1
          className="text-h1 font-bold text-ellipsis flex-1 overflow-hidden whitespace-nowrap"
          title={data?.fullName}
        >
          {data?.fullName}
        </h1>
        <Button
          variant="primary"
          borderRadius="soft"
          prefixIcon={<EditIcon />}
          onClick={() => navigate(generatePath(AppRoutes.FACE_ID_PROFILE_UPDATE, { id: id }))}
        >
          Edit Profile
        </Button>
      </div>

      {/* Details Card */}
      {isFetching && <Loading fullScreen />}
      {data && <FaceIdProfileDetailsCard profile={data} />}
    </div>
  );
};

export default FaceIdProfileDetails;
